import { Link, useSearchParams } from "react-router-dom";
import { t } from "../../lib/i18n";

const NEXT = { settings: "qr", qr: "admin", admin: "done" } as const;

export function SetupReturnBanner() {
  const [params] = useSearchParams();
  const step = params.get("setup");
  if (!step || !Object.hasOwn(NEXT, step)) return null;
  const next = NEXT[step as keyof typeof NEXT];
  return (
    <section className="setup-banner" aria-label={t("setup.returnTitle")}>
      <div className="setup-banner__body">
        <strong className="setup-banner__title">{t("setup.returnTitle")}</strong>
        <p className="setup-banner__subtitle">{t("setup.returnHint")}</p>
      </div>
      <div className="setup-banner__actions">
        <Link className="btn btn--secondary btn--sm" to={`/setup/${step}`}>
          {t("setup.returnAction")}
        </Link>
        <Link className="btn btn--primary btn--sm" to={`/setup/${next}`}>
          {t("setup.action.next")}
        </Link>
      </div>
    </section>
  );
}
